import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import
{
    ExecutionResult,
    GetPacketDetailModel,
    IPacketService,
    JournalEntryViewModel,
    PayableViewModel,
    PaymentCardViewModel,
    ProcessViewModel,
    PurchaseOrderInvoiceViewModel,
} from "@tylertech/tyler-api-types";
export interface IPacketExtendedService extends IPacketService
{
    GetPacketDetails(fields: GetPacketDetailModel): Promise<unknown>;
    GetProcessIdByPacketId(pPacketId: string): Promise<string>;
}
@Injectable()
export class PacketService implements IPacketExtendedService
{
    constructor(
        private readonly $apiService: ApiService
    ) { }

    GetAPPayablePacketDetails(pPacketDetailModel: GetPacketDetailModel): Promise<ExecutionResult<PayableViewModel[]>>
    {
        return this.$apiService.sendAuth("IPacketService/GetAPPayablePacketDetails", pPacketDetailModel);
    }

    GetAPPaymentPacketDetails(
        pPacketDetailModel: GetPacketDetailModel
    ): Promise<ExecutionResult<PaymentCardViewModel[]>>
    {
        return this.$apiService.sendAuth("IPacketService/GetAPPaymentPacketDetails", pPacketDetailModel);
    }

    GetDashboardProcesses(): Promise<ProcessViewModel[]>
    {
        return this.$apiService.sendAuth("IPacketService/GetDashboardProcesses");
    }

    GetGLPacketDetails(pPacketDetailModel: GetPacketDetailModel): Promise<ExecutionResult<JournalEntryViewModel[]>>
    {
        return this.$apiService.sendAuth("IPacketService/GetGLPacketDetails", pPacketDetailModel);
    }

    GetPOPacketDetails(
        pPacketDetailModel: GetPacketDetailModel
    ): Promise<ExecutionResult<PurchaseOrderInvoiceViewModel[]>>
    {
        return this.$apiService.sendAuth("IPacketService/GetPOPacketDetails", pPacketDetailModel);
    }

    GetProcessIdByPacketId(packetId: string): Promise<string>
    {
        return this.$apiService.sendAuth("IPacketService/GetProcessIdByPacketId", packetId);
    }

    GetPacketDetails(fields: GetPacketDetailModel): Promise<unknown>
    {
        const self = this;
        switch (fields.AggregateProviderId)
        {
            case "Purchasing.PacketApproval":
                return this.GetPOPacketDetails(fields)
                    .then(x => x.Result);
            case "GeneralLedger.PacketApproval":
                return this.GetGLPacketDetails(fields)
                    .then(x => x.Result);
            case "AccountsPayable.PacketApproval":
                return getApPacketDetails(fields)
                    .then(x => x.Result);
        }
        function getApPacketDetails(pPacketDetailModel: GetPacketDetailModel): Promise<ExecutionResult<unknown>>
        {
            switch (pPacketDetailModel.PacketProcessType)
            {
                case "APPayable":
                    return self.GetAPPayablePacketDetails(pPacketDetailModel);
                case "APPayment":
                    return self.GetAPPaymentPacketDetails(pPacketDetailModel);
                case "APDirect":
                    return pPacketDetailModel.AlternateType === "APDirectPayable"
                        ? self.GetAPPayablePacketDetails(pPacketDetailModel)
                        : self.GetAPPaymentPacketDetails(pPacketDetailModel);
            }
        }
    }
}
